import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';

@Component({
  selector: 'app-segment-modal',
  templateUrl: './segment-modal.component.html',
  styleUrls: ['./segment-modal.component.scss']
})
export class SegmentModalComponent {
  isEditMode: boolean = false;
  Segments: any;
  form: any;

  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<SegmentModalComponent>,
    private municipalitieService: SegmentsService,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
  ) {
    this.form = this._fb.group({
      name: [null, Validators.required],
      description: [null],
      initialKm: [null, this.requiredNonNull()],
      finalKm: [null, Validators.required],
      extensionKm: [{ value: null, disabled: true }],
    }, { validators: this.kmFinalMaiorQueKmInicial });

  }

  ngOnInit(): void {
    this.isEditMode = this.uploadData.isEditMode

    this.Segments = this.uploadData.segment

    if (this.isEditMode) {

      this.populatingData()
    }

    this.form.get('initialKm').valueChanges.subscribe(() => this.updateExtensao());
    this.form.get('finalKm').valueChanges.subscribe(() => this.updateExtensao());

  }

  populatingData() {

    this.form.patchValue({
      name: this.Segments.name,
      description: this.Segments.description,
      initialKm: this.Segments.initialKm,
      finalKm: this.Segments.finalKm,
      extensionKm: this.Segments.extensionKm,
    })
  }

  updateExtensao() {
    const inicio = this.form.get('initialKm').value;
    const final = this.form.get('finalKm').value;

    if (inicio != null && final != null && final > inicio) {
      const extensao = final - inicio;


      const extensaoFormatada = parseFloat(extensao.toFixed(2));

      this.form.get('extensionKm').setValue(extensaoFormatada);
    } else {
      this.form.get('extensionKm').setValue(null);
    }
  }

  kmFinalMaiorQueKmInicial(group: FormGroup): ValidationErrors | null {
    const initialKmControl = group.get('initialKm');
    const finalKmControl = group.get('finalKm');
  
    if (!initialKmControl || !finalKmControl) {
      return null;
    }
  
    const inicio = initialKmControl.value;
    const final = finalKmControl.value;
  
    if (inicio !== null && final !== null && final <= inicio) {
      finalKmControl.setErrors({ kmInvalido: true }); // Define erro no campo finalKm
      return { kmInvalido: true };
    } else {
      // Remove erro se for válido
      if (finalKmControl.hasError('kmInvalido')) {
        finalKmControl.setErrors(null);
      }
      return null;
    }
  }
  requiredNonNull(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      // Aceita 0 como válido, mas não aceita valores nulos ou indefinidos
      return value === null || value === undefined || value === '' ? { required: true } : null;
    };
  }
  onSubmit() {
    let data = {
      ...this.form.value,
      extensionKm: this.form.get('extensionKm').value
    }
    this.dialogRef.close(data)

  }

  back() {
    this.dialogRef.close()
  }



}
